import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { RouteNameEnum } from '@connect-services/client/models/routes.model';
import {
    FEATURE_SESSION_STORE_KEY,
    FEATURE_TRACKED_STORE_KEY,
    FeatureSessionService,
} from '@connect-services/client/services/feature-session.service';
import { FeatureSession } from '@connect-services/src/sdk/api';

export async function featureSessionResolver(route: ActivatedRouteSnapshot): Promise<void> {
    const featureTracked: FeatureSession.FeatureTrackedEnum | RouteNameEnum.HOME = route.data['featureSession'];
    if (route.children.length && featureTracked === RouteNameEnum.HOME) {
        return;
    }

    const storedFeatureTracked = sessionStorage.getItem(FEATURE_TRACKED_STORE_KEY);

    if (featureTracked === storedFeatureTracked) {
        return;
    }

    const services = {
        featureSessionService: inject(FeatureSessionService),
    };

    const featureSession = sessionStorage.getItem(FEATURE_SESSION_STORE_KEY);

    if (featureSession) {
        await services.featureSessionService.endSession(featureSession);
    }

    if (!featureTracked || featureTracked === RouteNameEnum.HOME) {
        return;
    }

    await services.featureSessionService.startFeatureSession(featureTracked);
}
